<template>
  <div class="projectReportDialog_User">
    <div >
    <div class="tableContainer">
      <div class="tableContent" id="tableContent">
          <el-table :data="dataList" border stripe>
            <el-table-column prop="userName" label="姓名" width="120" fixed="left"></el-table-column>
            <el-table-column prop="organizationName" label="投入时所在组织机构" width="300" fixed="left"></el-table-column>
            <el-table-column prop="spentTime" label="总计" width="100">
              <template slot-scope="props">
                {{props.row.spentTime | hoursToDays}}
              </template>
            </el-table-column>
            <el-table-column v-for="val in taskList" :key="val" width="200">
              <template slot="header">
                {{
                val.split('-')[1]
                }}
              </template>
              <template slot-scope="props">{{props.row[val]| hoursToDays}}</template>
            </el-table-column>
          </el-table>
      </div>
       <div class="tablePagesNumber">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.PagingInfo.currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="listQuery.PagingInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.PagingInfo.totalCount"></el-pagination>
      </div>
    </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "projectReportDialog_User",
  props: ["projectReportDialogChildProps"],
  data() {
    return {
      dataList: [],
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          projectId:"",
          startDate: "",
          endDate: ""
        }
      },
      taskList:[]
    };
  },
  mounted(){

    // this.clear();
    // this.show();

  },
  methods: {
    clear(){
        this.dataList = [];
        
    },
    show(){
       this.getDataList();
    },

    getDataList() {
      
      this.listQuery.Parameters.projectId= this.projectReportDialogChildProps.projectId;

      this.$reportApi.getUserSpentTimeDataTableGroupByProject(this.listQuery)
        .then(res => {
          if (res.data.successful) {
            this.dataList = res.data.data.data;
            this.listQuery.PagingInfo.totalCount = res.data.data.pagingInfo.totalCount;
            
            this.getTaskTableColumnList()

          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      
    },

    getTaskTableColumnList(){
        let taskList = [];
        this.dataList.forEach(item=>{
            for(let key in item){
                if(key.indexOf('-') !='-1'){
                    taskList.push(key)
                }
            }
        })
        // 数组去重
        this.taskList =[...new Set(taskList)];
    },

    searchTable() {
      this.getDataList();
    },
    chooseData(args) {
      this.$emit("chooseProjectCallback", args);
      this.propsData.visible = false;
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.getDataList();
    },
    closeDialog() {
      this.listQuery.Parameters.keyword = "";
      this.propsData.visible = false;
      document.getElementById('tableContent').scrollTop = 0;
      
    }
  }
}
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  .projectReportDialog_User{

    .tableContainer{
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 0px;
      right: 0px;
      overflow: hidden;
      
    }

    .tableContent {
      border: 1px solid #ebeef5;
      height: calc(100% - 50px);
      overflow: auto;
    }

    .tablePagesNumber {
        position: absolute;
        bottom: 0;
        right: 20px;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/views/report/projectReportDialog_User.vue